exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * ADOBE CONFIDENTIAL\n * ___________________\n *\n * Copyright 2019 Adobe. All Rights Reserved.\n *\n * NOTICE: All information contained herein is, and remains\n * the property of Adobe Inc. and its suppliers, if any. The intellectual\n * and technical concepts contained herein are proprietary to Adobe Inc.\n * and its suppliers and are protected by all applicable intellectual\n * property laws, including trade secret and copyright laws.\n * Dissemination of this information or reproduction of this material\n * is strictly forbidden unless prior written permission is obtained\n * from Adobe Inc.\n */\n._1TKKYFDfjrVO9RzCVWfSKN {\n  font-size: var(--ccx-comments-empty-state-cta-font-size); }\n", ""]);

// exports
exports.locals = {
	"commentsShareForReviewBtn": "_1TKKYFDfjrVO9RzCVWfSKN"
};